import { createRouter } from '@tanstack/react-router'

import { routeTree } from '@/route-tree.gen'

import { PagePending } from '@/app/layouts'
import { queryClient } from '@/app/providers'

export const router = createRouter({
  routeTree,
  // Routes read the cache in `beforeLoad` and `loader`, so the chunk and its
  // data load in parallel instead of waterfalling after mount.
  context: { queryClient },
  defaultPreload: 'intent',
  defaultPreloadStaleTime: 0,
  /**
   * A page inside a shell that is already on screen. The whole-shell stand-in
   * is `AppShellSkeleton`, and it belongs to `_auth` alone — as a default it
   * drew a second rail and a second column nested inside the first on every
   * navigation between tiles.
   */
  defaultPendingComponent: PagePending,
  /*
   * `defaultPendingMs` and `defaultPendingMinMs` are deliberately absent: the
   * library's 1000 / 500 are right and picking our own numbers would be
   * guessing against them.
   *
   * 1000ms to show anything is Nielsen's own threshold — under a second a delay
   * does not interrupt the flow of thought and needs no feedback, so a
   * navigation that resolves inside it should simply produce the finished page.
   * 500ms minimum once shown is what stops the placeholder appearing for a
   * frame and vanishing: the threshold is met, the data lands right after, and
   * the result is the flash this whole branch exists to remove.
   *
   * `_auth` overrides the first to 0. On the very first load there is no
   * previous page to keep and any delay is a blank frame where the boot shell
   * used to be.
   */
  scrollRestoration: true,
})

// Declaration merging against the router library: the one sanctioned use of
// `interface`.
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}
